const subscribeToFatalErrorStream = (
    fatalError$,
    player
) =>
    fatalError$
        .subscribe(error => {
            player.exitFullscreen();
            player.error(error.type);
        });

export default subscribeToFatalErrorStream;
